
export default {
  name: 'TermAndConditions',
  props: {
    isLoading: Boolean
  },
  data() {
    return {
      termsAccepted: false
    }
  },
  watch: {
    termsAccepted(newValue) {
      this.$emit('terms-accepted', newValue)
    }
  }
}
